import { RouteDefinition } from '@bz/ui';
import { Location, createAsync } from '@solidjs/router';

export function loginGuard(route: RouteDefinition): RouteDefinition {
  const Component = route.component;
  const needLogin = route.info?.login;
  if (needLogin !== undefined && Component) {
    route.component = (props) => {
      const [, others] = splitProps(props, ['children']);
      const location = useLocation();
      const canRender = createAsync<boolean>(() => loginQuery(location, needLogin));

      return (
        <Component {...others}>
          <Show when={import.meta.env.SSR ? canRender() : true}>{props.children}</Show>
        </Component>
      );
    };
  } else if (route.children) {
    route.children =
      route.children instanceof Array ? route.children.map((it) => loginGuard(it)) : loginGuard(route.children);
  }
  return route;
}

export function loginBeforeRoute(match: RouteDefinition, location: Location) {
  /**
   * 路由前登录守卫
   * SSR模式不在此进行重定向，它始终依赖query的response error code
   * info.login是一个三态的标志 true false undefined
   * true 必须要登录才能进入该路由，否则重定向到/login?redirect并跟随
   * false 必须非登录才能进入该路由，否则重定向到/
   * undefined 默认值，该路由和登录状态无关
   */
  if (import.meta.env.SSR) return false;
  const needLogin = match.info?.login;
  return getRedirect(location, needLogin);
}

const loginQuery = query(async (location: Location, needLogin?: boolean) => {
  const url = getRedirect(location, needLogin);
  if (url) {
    throw redirect(url);
  }
  // 这里的true单纯表示当前组件可以被渲染，不能渲染都重定向走了
  return true;
}, 'is-login');

function getRedirect(location: Location, needLogin?: boolean): false | string {
  const isLogin = account.isLogin;
  if (!isLogin && needLogin === true) {
    return `/login?redirect=${encodeURIComponent(location.pathname + location.search)}`;
  }

  return false;
}
